
import $ from 'jquery';

import 'intersection-observer';
import 'jquery.easing';

import globalelements from './global/elements';


export default function (options) {
    var o = $.extend({
        $e: null,
        tierSelector: 'section',

        devMode: true
    }, options);


    var ele = {
        win: $(window),
        doc: $(document),
        body: $('body'),

        tiers: $(o.tierSelector),

        gridOverlay: null,
        devBar: null
    };


    var internal = {
        name: 'Dev',
        $e: o.$e || $(o.selector),

        winWidth: globalelements.win.width(),

        currentFilter: o.filter
    };


    var fn = {
        init: function () {
            if (!o.devMode) return;

            // fn.setupStreamControls();
            fn.setupGridOverlay();
            fn.setupDevBar();

            globalelements.win.on('keydown', handlers.keydown);
            globalelements.doc.on('devBarMsg', handlers.devBarMsg);
        },

        setupStreamControls: function () {
            if (ele.tiers.length < 1) return;

            ele.tiers.each(function (i) {
                var tier = $(this);
                var tierBackgroundColor = (function () {
                    var rgb, hex;
                    rgb = tier.css('background-color');
                    rgb = rgb.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(,\s*\d+\.*\d+)?\)$/);
                    hex = (!rgb ? '#ffffff' : '#' + ('0' + parseInt(rgb[1]).toString(16)).slice(-2) + ('0' + parseInt(rgb[2]).toString(16)).slice(-2) + ('0' + parseInt(rgb[3]).toString(16)).slice(-2));
                    return hex;
                })();
                var tierControlsMarkup = '' +
                    '<div class="dev-tier-controls" style=' +
                        'background:' + tierBackgroundColor + ';' +
                        (tier.data('text') ? 'color:' + tier.data('text') : '') +
                    '</div>';
                var tierControls = $(tierControlsMarkup);

                tier.append(tierControls);

                // controls title
                var tierTitle;
                if (tier.is('.tier--text')) {
                    tierTitle = 'Text Tier';
                } else if (tier.is('.tier--media')) {
                    tierTitle = 'Media Tier';
                } else if (tier.is('.tier--array')) {
                    tierTitle = 'Array Tier';
                } else if (tier.is('.tier--twoup')) {
                    tierTitle = 'Two-up Tier';
                } else if (tier.is('.tier--slideshow')) {
                    tierTitle = 'Slideshow Tier';
                } else if (tier.is('.tier--pano')) {
                    tierTitle = 'Panorama Tier';
                } else if (tier.is('.tier--sticky')) {
                    tierTitle = 'Sticky Tier';
                }

                $('<h4>' + tierTitle + '</h4><div></div>').appendTo(tierControls);

                // position
                var upMarkup = '<input class="dev-tier-controls-up" type="button" value="&uarr;" ' + (i === 0 ? 'disabled' : '') + '>';
                var downMarkup = '<input class="dev-tier-controls-down" type="button" value="&darr;" ' + (i === ele.tiers.length - 1 ? 'disabled' : '') + '>';

                var up = $(upMarkup).on('click', function () {
                    var prevTier = tier.prev(o.tierSelector);

                    prevTier.insertAfter(tier);

                    $('.dev-tier-controls-up, .dev-tier-controls-down')
                        .removeAttr('disabled');

                    var allTiers = $(o.tierSelector);
                    allTiers.first()
                        .find('.dev-tier-controls-up')
                        .attr('disabled', '');

                    allTiers.last()
                        .find('.dev-tier-controls-down')
                        .attr('disabled', '');
                });
                var down = $(downMarkup).on('click', function () {
                    var nextTier = tier.next(o.tierSelector);

                    nextTier.insertBefore(tier);

                    $('.dev-tier-controls-up, .dev-tier-controls-down')
                        .removeAttr('disabled');

                    var allTiers = $(o.tierSelector);
                    allTiers.first()
                        .find('.dev-tier-controls-up')
                        .attr('disabled', '');

                    allTiers.last()
                        .find('.dev-tier-controls-down')
                        .attr('disabled', '');
                });

                $('<div class="dev-tier-doublebox"></div>')
                    .appendTo(tierControls)
                    .append(up)
                    .append(down)
                    .after('<label>Position</label>');


                // background color
                var backgroundInputMarkup = '<input type="color">';

                $(backgroundInputMarkup)
                    .appendTo(tierControls)
                    .val(tierBackgroundColor)
                    .on('change', function (e) {
                        tier.css('background-color', $(this).val());
                    })
                    .after('<label>Background</label>');

                // text color
                var textColorSelectMarkup = '' +
                    '<select>' +
                        '<option value="white">white</option>' +
                        '<option value="black">black</option>' +
                    '</select>';

                $(textColorSelectMarkup)
                    .appendTo(tierControls)
                    .val(tier.data('text'))
                    .on('change', function (e) {
                        tier.attr('data-text', $(this).val());
                    })
                    .after('<label>Text Color</label>');

                // margins
                var marginSelectMarkup = '' +
                    '<select>' +
                        '<option value="none">none</option>' +
                        '<option value="single">single</option>' +
                        '<option value="double">double</option>' +
                        '<option value="gutter">gutter width</option>' +
                    '</select>';

                $(marginSelectMarkup)
                    .appendTo(tierControls)
                    .val(tier.data('top-margin'))
                    .on('change', function (e) {
                        tier.attr('data-top-margin', $(this).val());
                    })
                    .after('<label>Top margin</label>');

                $(marginSelectMarkup)
                    .appendTo(tierControls)
                    .val(tier.data('bottom-margin'))
                    .on('change', function (e) {
                        tier.attr('data-bottom-margin', $(this).val());
                    })
                    .after('<label>Bottom margin</label>');

                // layout select for two-ups
                if (tier.is('[data-layout^=twoup')) {
                    var layoutSelectMarkup = '' +
                        '<select>' +
                            '<option value="twoup-3x9">3 col x 9 col</option>' +
                            '<option value="twoup-4x8">4 col x 8 col</option>' +
                            '<option value="twoup-6x6">6 col x 6 col</option>' +
                            '<option value="twoup-8x4">8 col x 4 col</option>' +
                            '<option value="twoup-9x3">9 col x 3 col</option>' +
                        '</select>';

                    var staggerSelectMarkup = '' +
                        '<select>' +
                            '<option value="no">no stagger</option>' +
                            '<option value="yes">yes stagger</option>' +
                        '</select>';

                    $(layoutSelectMarkup)
                        .appendTo(tierControls)
                        .val(tier.data('layout'))
                        .on('change', function (e) {
                            tier.attr('data-layout', $(this).val());
                        })
                        .after('<label>Two-up layout</label>');

                    $(staggerSelectMarkup)
                        .appendTo(tierControls)
                        .val(tier.data('stagger'))
                        .on('change', function (e) {
                            tier.attr('data-stagger', $(this).val());
                        })
                        .after('<label>Two-up stagger</label>');
                }

                // array layout select
                if (tier.is('[data-array]')) {
                    var arraySelectMarkup = '' +
                        '<select>' +
                            '<option value="two">two-up</option>' +
                            '<option value="three">three-up</option>' +
                            '<option value="four">four-up</option>' +
                        '</select>';

                    $(arraySelectMarkup)
                        .appendTo(tierControls)
                        .val(tier.data('array'))
                        .on('change', function (e) {
                            tier.attr('data-array', $(this).val());
                        })
                        .after('<label>Array layout</label>');
                }

                // text & media tier alignment
                if (tier.is('.tier--text') || tier.is('.tier--media')) {
                    var alignMarkup = '' +
                        '<select>' +
                            '<option value="left">left</option>' +
                            '<option value="center">center</option>' +
                            '<option value="right">right</option>' +
                        '</select>';

                    $(alignMarkup)
                        .appendTo(tierControls)
                        .val(tier.data('align'))
                        .on('change', function (e) {
                            tier.attr('data-align', $(this).val());
                        })
                        .after('<label>Alignment</label>');
                }

                // text tier width
                if (tier.is('.tier--text')) {
                    var textWidthMarkup = '' +
                        '<select>' +
                            '<option value="col4">4 columns</option>' +
                            '<option value="col6">6 columns</option>' +
                            '<option value="col8">8 columns</option>' +
                        '</select>';

                    $(textWidthMarkup)
                        .appendTo(tierControls)
                        .val(tier.data('width'))
                        .on('change', function (e) {
                            tier.attr('data-width', $(this).val());
                        })
                        .after('<label>Text max width</label>');
                }

                // media tier width
                if (tier.is('.tier--media')) {
                    var mediaWidthMarkup = '' +
                        '<select>' +
                            '<option value="col4">4 columns</option>' +
                            '<option value="col6">6 columns</option>' +
                            '<option value="col8">8 columns</option>' +
                            '<option value="col12">12 columns</option>' +
                            '<option value="fullbleed">fullbleed</option>' +
                        '</select>';

                    $(mediaWidthMarkup)
                        .appendTo(tierControls)
                        .val(tier.data('width'))
                        .on('change', function (e) {
                            tier.attr('data-width', $(this).val());
                        })
                        .after('<label>Media width</label>');
                }

                // sticky tier
                if (tier.is('.tier--twoup')) {
                    var stickySideMarkup = '' +
                        '<select>' +
                            '<option value="none">none</option>' +
                            '<option value="left">left</option>' +
                            '<option value="right">right</option>' +
                        '</select>';

                    $(stickySideMarkup)
                        .appendTo(tierControls)
                        .val(tier.data('sticky') || 'none')
                        .on('change', function (e) {
                            tier.attr('data-sticky', $(this).val());
                        })
                        .after('<label>Sticky side</label>');
                }
            });
        },

        setupGridOverlay: function () {
            var gridOverlayMarkup = '' +
                '<div class="devgrid" id="devgrid">' +
                    '<div class="devgrid-col"></div>' +
                    '<div class="devgrid-col"></div>' +
                    '<div class="devgrid-col"></div>' +
                    '<div class="devgrid-col"></div>' +
                    '<div class="devgrid-col"></div>' +
                    '<div class="devgrid-col"></div>' +
                    '<div class="devgrid-col"></div>' +
                    '<div class="devgrid-col"></div>' +
                    '<div class="devgrid-col"></div>' +
                    '<div class="devgrid-col"></div>' +
                    '<div class="devgrid-col"></div>' +
                    '<div class="devgrid-col"></div>' +
                '</div>';

            ele.gridOverlay = $(gridOverlayMarkup);

            globalelements.body.append(ele.gridOverlay);
        },

        setupDevBar: function () {
            var devBarMarkup = '<div class="devbar" id="devbar"></div>';

            ele.devBar = $(devBarMarkup);

            globalelements.body.append(ele.devBar);
        },
        showDevBar: function (txt) {
            ele.devBar.text(txt);
            ele.devBar.finish().fadeIn(200).delay(2000).fadeOut(200);
        },

        console: function (msg) {
            if (o.devMode) console.log(internal.name + '.js | ' + msg);
        }
    };


    var handlers = {
        keydown: function (e) {
            if (e.key === 'g') {
                ele.gridOverlay.toggle();
                fn.showDevBar('Grid guides toggled');
            } else if (e.key === 't') {
                $('.dev-tier-controls').toggle();
                fn.showDevBar('Tier options toggled');
            }
        },
        devBarMsg: function (e, d) {
            var msg = (d && d.msg ? d.msg : e.originalEvent.detail);
            fn.showDevBar(msg);
        }
    };


    fn.init();
}
